import {format} from "date-fns";

export function formatDateToDDMMYYYY(date: Date): string {
    if(date === null) {
        return ""
    }
    return format(date, 'dd/MM/yyyy');
}